"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableModules = void 0;
exports.availableModules = new Set([
    { value: 'DAILY_REPORTS', text: 'Daily Reports' },
    { value: 'ESUB_DRIVE', text: 'eSUB Drive' },
    { value: 'FIELD_NOTES', text: 'Field Notes' },
    { value: 'RFI', text: 'RFIs' },
    { value: 'TIME_CARD_MANAGEMENT', text: 'Time Card Management' },
    { value: 'SUBMITTALS', text: 'Submittals' },
    { value: 'MAILBOX', text: 'Mailbox' },
    { value: 'CHANGE_ORDER_REQUEST', text: 'Change Orders' },
    { value: 'PURCHASE_ORDER', text: 'Purchase Orders' },
    { value: 'DRAWINGS', text: 'Drawings' },
    { value: 'JOB_COST_REPORT', text: 'Job Cost Reports' },
    { value: 'INTEGRATIONS', text: 'Integrations' },
]);
